import { getFormsState } from './../../forms/forms.selectors'
import { FetchFormsRequest } from './../../forms/forms.actions'
import {
  SetDefaultData,
  FetchDataCycleRequest,
  UpdateField,
  UpdateDataCycleRequest,
} from '../data-cycles.actions'
import { getUpdateDataCycleState } from '../data-cycles.selectors'
import Validator from '@shared/validatorjs/src/validator'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Map } from 'immutable'
import { Subscription } from 'rxjs'
import { toDate } from '@shared/shared.utils'

@Component({
  selector: 'app-update-data-cycle',
  templateUrl: './update-data-cycle.component.html',
  styleUrls: ['./update-data-cycle.component.css'],
})
export class UpdateDataCycleComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public isLoading: boolean
  public userId: number
  private state$: Subscription
  public forms: []
  private formsState$: Subscription

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.userId = parseInt(this.route.snapshot.paramMap.get('id'), 10)
    this.store.dispatch<any>(new SetDefaultData('updateDataCycle'))

    this.state$ = this.store
      .pipe(select(getUpdateDataCycleState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.formsState$ = this.store
      .pipe(select(getFormsState))
      .subscribe((state) => {
        this.forms = state.get('data').toJS()
      })

    this.store.dispatch<any>(new FetchDataCycleRequest(this.userId))
    this.store.dispatch<any>(
      new FetchFormsRequest({
        pageSize: 500,
      }),
    )
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.formsState$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'updateDataCycle.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'updateDataCycle',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      name: 'required',
    }
    const validator = new Validator(
      {
        name: data.get('name'),
      },
      rules,
    )

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state
      .get('data')
      .set(
        'paymentDeadline',
        toDate(this.state.get('data').get('paymentDeadline')),
      )
      .set(
        'proposedEndDate',
        toDate(this.state.get('data').get('proposedEndDate')),
      )
      .set('startDate', toDate(this.state.get('data').get('startDate')))
      .set(
        'earlyPaymentDiscountDeadline',
        toDate(this.state.get('data').get('earlyPaymentDiscountDeadline')),
      )
      .set(
        'earlyPaymentDiscountDeadlineBusiness',
        toDate(
          this.state.get('data').get('earlyPaymentDiscountDeadlineBusiness'),
        ),
      )
      .set(
        'earlyPaymentDiscountDeadlineCompounds',
        toDate(
          this.state.get('data').get('earlyPaymentDiscountDeadlineCompounds'),
        ),
      )
      .toJS()

    if (validation.passes()) {
      this.store.dispatch(new UpdateDataCycleRequest(this.userId, payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'updateDataCycle',
        ),
      )
    }
  }
}
